// extracted by mini-css-extract-plugin
export var content = "dropdown-module--content--781cd";
export var dropdown = "dropdown-module--dropdown--db19c";
export var open = "dropdown-module--open--1b0ba";
export var title = "dropdown-module--title--9d2ae";